import React from "react";
import { UxIcon, UxIconEnum, useSpeechStream } from "@imaginelearning/mps-ux-component-library";
import "./audiobutton.scss";
import useUser from "../../../hooks/useuser";

interface IAudioButtonProps {
  container: string;
}

function AudioButton(props: IAudioButtonProps) {
  const { user } = useUser();
  const isSpanishLanguage = user?.spanishLanguage?.includes("math") || user?.spanishLanguage?.includes("Math");
  const { play, pause, isPlaying, isAvailable } = useSpeechStream(isSpanishLanguage);

  const playAudio = () => {
    if (isPlaying) {
      pause();
    } else {
      play(props.container);
    }
  };

  return (
    <button className="btn btn-primary audiobutton" onClick={playAudio}>
      <UxIcon icon={isPlaying ? UxIconEnum.PAUSE : UxIconEnum.PLAY} />
    </button>
  );
}

export default AudioButton;
